export default __webpack_public_path__ + "static/media/none-content.47efab17.svg";